import { Button, FormGroup, InputGroup } from '@blueprintjs/core'
import { Dialog, lang, toast } from 'enablex/shared'
import React, { FC, useState } from 'react'
import api from '~/app/api'

interface Department {
  id: number
  name: string
  email?: string
  status: 'active' | 'suspended'
  workspaceId: string
  createdAt: Date
  updatedAt: Date
}

interface Props {
  isOpen?: boolean
  toggleOpen?: () => void
  onDepartmentCreated?: (newDepartment: Department) => void
}

export const CreateDepartmentModal: FC<Props> = props => {
  const [name, setName] = useState<string>('')
  const [email, setEmail] = useState<string>('')

  const isValid = name.trim().length > 0

  const createDepartment = async () => {
    if (!name.trim()) {
      return
    }

    try {
      const { data } = await api.getSecured().post('/admin/workspace/departments', {
        name,
        email
      })
      toast.success('Department created successfully!')
      props.onDepartmentCreated && props.onDepartmentCreated(data.payload)
    } catch (err) {
      // Extract error message from API response
      const errorMessage = err.response?.data?.message || 'Failed to create department'
      toast.failure(errorMessage)
    }
  }

  const handleClose = () => {
    setName('')
    setEmail('')
    props.toggleOpen && props.toggleOpen()
  }

  return (
    <Dialog.Wrapper
      title="Create Department"
      icon="add"
      isOpen={props.isOpen}
      onClose={handleClose}
      onSubmit={createDepartment}
    >
      <Dialog.Body>
        <FormGroup
          label="Department Name"
          labelFor="input-name"
          helperText="Enter a unique name for the department"
        >
          <InputGroup
            id="input-name"
            value={name}
            onChange={e => setName(e.target.value)}
            autoFocus={true}
            placeholder="Enter department name"
          />
        </FormGroup>
        <FormGroup
          label="Email (Optional)"
          labelFor="input-email"
          helperText="Contact email for the department"
        >
          <InputGroup
            id="input-email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="Enter department email"
            type="email"
          />
        </FormGroup>
      </Dialog.Body>
      <Dialog.Footer>
        <Button
          id="btn-submit-create-department"
          type="submit"
          text="Create Department"
          disabled={!isValid}
        />
      </Dialog.Footer>
    </Dialog.Wrapper>
  )
}

export default CreateDepartmentModal
